'use client';

import { useRef } from 'react';

const safeDocument: Document | null = typeof document !== 'undefined' ? document : null;

/**
 * @link https://gist.github.com/reecelucas/2f510e6b8504008deaaa52732202d2da
 */
export function useScrollBlock(): [() => void, () => void] {
	const scrollBlocked = useRef<boolean>(false);
	const body = safeDocument?.body;

	const blockScroll = (): void => {
		if (!body || !body?.style || scrollBlocked.current) return;

		let scrollbarWidth = window.innerWidth - body.clientWidth;

		if (scrollbarWidth > 0) {
			body.style.paddingRight = `${scrollbarWidth}px`;
			const header = document.getElementsByClassName('header').item(0) as HTMLElement;
			const topSection = document.getElementsByClassName('top-section').item(0) as HTMLElement;

			if (header) {
				header.style.paddingRight = `${scrollbarWidth}px`;
				header.style.width = `calc(100% + ${scrollbarWidth}px)`;
			}

			if (topSection) {
				topSection.style.width = `calc(100% + ${scrollbarWidth * 2}px)`;
			}
		}

		body.style.overflow = 'hidden';

		scrollBlocked.current = true;
	};

	const allowScroll = (): void => {
		if (!body || !body.style) return;

		body.style.overflow = '';
		body.style.paddingRight = '';
		body.style.width = '';

		const header = document.getElementsByClassName('header').item(0) as HTMLElement;
		const topSection = document.getElementsByClassName('top-section').item(0) as HTMLElement;

		if (header) {
			header.style.paddingRight = '';
			header.style.width = '';
		}

		if (topSection) {
			topSection.style.width = '';
		}

		scrollBlocked.current = false;
	};

	return [blockScroll, allowScroll];
}
